<!--title -->
<app-modal-title
  [title]="'common.addMobile' | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<form [formGroup]="form" autocomplete="off">
  <!-- step1 insert mobile-->
  <section class="tw-m-[20px]">
    <div class="tw-flex-center flex-column">
      <form-field
        type="tel"
        class="tw-w-full"
        label="common.mobile"
        [control]="form?.get('mobile')"
        [isOnlyNumber]="true"
        [maxLength]="12"
        [(value)]="mobile"
      >
        <i suffix-content class="mdi mdi-cellphone mdi-23px"></i>
      </form-field>

      <!-- submit button -->
      <button
        [disabled]="form.get('mobile')?.invalid || !mobile"
        mat-ripple
        class="btn btn-hover-rise tw-mt-3 tw-w-full"
        [themeColor]="'btn'"
        (click)="onClose(mobile)"
      >
        <span *ngIf="!loading"> {{ "common.submit" | translate }}</span>
        <!-- loading -->
        <ng-container *ngIf="loading">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <span class="sr-only">Loading...</span>
        </ng-container>
      </button>
    </div>
  </section>
</form>
